import React, { FC } from "react";
import cx from "classnames";

export type HorizontalRuleProps = {
  className?: string;
};

export const HorizontalRule: FC<HorizontalRuleProps> = ({
  className = "my-6",
}) => {
  return <hr className={cx("grey-100-bg opacity-100", className)} />;
};
